import { useState } from "react";
import useDocumentTitle from "../../../shared/customHooks/useDocumentTitle";

import DocumentsSummaryBar from "../components/DocumentsSummaryBar";
import DocumentsActionsPanel from "../components/DocumentsActionsPanel";
import DocumentsFilterPanel from "../components/DocumentsFilterPanel";
import DocumentsGrid from "../components/DocumentsGrid";

const AdminDocumentPage = () => {

  useDocumentTitle("Admin Documents");

  const [filters, setFilters] = useState(null);
  const [gridFilters, setGridFilters] = useState(null);
  const [selectedRows, setSelectedRows] = useState([]);
  const [reloadGrid, setReloadGrid] = useState(false);
  const [reapplyFilters, setReapplyFilters] = useState(false);

  const handleFilter = (values) => {
    setFilters(values);
  };

  const handleGridFilter = (values) => {
    setGridFilters(values)
  }

  return (
    <>
      {/* TAB HEADER */}

      <ul className="nav nav-tabs">
        <li role="presentation" className="active">
          <a>Documents</a>
        </li>
      </ul>

      <div className="tab-content">

        {/* ROW 1 : SUMMARY */}

        <DocumentsSummaryBar 
        reloadSummary={reloadGrid} 
        stopReloadSummary={()=>setReloadGrid(false)} 
        clearFilters={()=>{setFilters(null); setGridFilters(null);}}
        setReapplyFilters={setReapplyFilters}
        />

        {/* ROW 2 : BUTTON PANEL */}

        <DocumentsActionsPanel
          selectedRows={selectedRows}
          reloadGrid={()=>setReloadGrid(true)}
        />

        <hr />

        {/* ROW 3 : FILTER PANEL */}

        <DocumentsFilterPanel
          onApplyFilter={handleFilter}
          applyGridFilter = {handleGridFilter}
          inputFilters ={filters}
          reapplyFilters = {reapplyFilters}
          setReapplyFilters={setReapplyFilters}
        />

        {/* ROW 4 : GRID */}

        <DocumentsGrid
          filters={gridFilters}
          onSelectionChange={setSelectedRows}
          reloadGrid={reloadGrid}
          stopReloadGrid={()=>setReloadGrid(false)}
        />

      </div>
    </>
  );
};

export default AdminDocumentPage;